// Единственный порог мобильного вида. Ниже него раскладка перестраивается в
// одну колонку, а верхние инструменты уезжают в бургер-меню.
//
// То же число стоит в медиазапросах CSS-модулей (@media (max-width: 720px)):
// custom property внутри @media не работает, поэтому порог живёт в двух местах
// и меняется только вместе. JS нужен там, где одной вёрсткой не обойтись:
// контрол не может одновременно стоять в полосе и в меню, его нужно перенести.
import { useEffect, useState } from 'react';

export const MOBILE_MAX_WIDTH = 720;
export const MOBILE_QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`;

function matchesMobile(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(MOBILE_QUERY).matches;
}

/** true, пока окно уже мобильного порога. Следит за поворотом экрана и ресайзом. */
export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState(matchesMobile);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(MOBILE_QUERY);
    const onChange = () => setMobile(mq.matches);
    // Между первым рендером и подпиской ширина могла измениться — сверяемся сразу.
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return mobile;
}
